<script>
export default {
  name: "CruciverbaView",
  data() {
    return {
      showClues: true,
      showResults: false,
      userAnswers: {},
      gridSize: { rows: 17, cols: 27 },
      
      // Definizione delle parole nel cruciverba (basato sul PDF originale)
      words: [
                // 1 - ASSISI (verticale)
        { 
          id: 1, 
          direction: 'down', 
          clue: "Dove è nato Francesco?", 
          answer: "ASSISI",
          row: 1, 
          col: 15, 
          number: 1,
          hints: { 1: 'A', 6: 'I' }
        },
        // 2 - OTTOBRE (Verticale)
        { 
          id: 2, 
          direction: 'down', 
          clue: "In che mese è nato Francesco d'Assisi?", 
          answer: "OTTOBRE",
          row: 3, 
          col: 10, 
          number: 2,
          hints: { 2: 'T', 7: 'E' }
        },
                // 3 - Giovanni (orizzontale)
        { 
          id: 3, 
          direction: 'across', 
          clue: "Qual'è il vero nome di Francesco d'Assisi?", 
          answer: "GIOVANNI",
          row: 6, 
          col: 8, 
          number: 3, 
          hints: { 6: 'N', 8: 'I' }
        },
                // 4 - mendicante (verticale)  
        { 
          id: 4, 
          direction: 'down', 
          clue: "Ispirato a condurre una vita cristiana di povertà, divenne un ... e un predicatore itinerante.", 
          answer: "MENDICANTE",
          row: 2, 
          col: 5, 
          number: 4,
          hints: { 2: 'E', 9: 'T', 10: 'E' }
        },
                // 5 - GREGORIO (orizzontale)
        { 
          id: 5, 
          direction: 'across', 
          clue: "Venne proclamato santo da Papa ... IX nel 1228", 
          answer: "GREGORIO",
          row: 3, 
          col: 3, 
          number: 5,
          hints: { 3: 'E', 5: 'O' }
        },
        // 6 - MILLEDUECENTOVENTIQUATTRO (orizzontale)
        { 
          id: 6, 
          direction: 'across', 
          clue: "Il Cantico delle creature è un cantico di San Francesco d'Assisi composto intorno al ...", 
          answer: "MILLEDUECENTOVENTIQUATTRO",
          row: 11, 
          col: 1, 
          number: 6,
          hints: { 1: 'M', 2: 'I', 3: 'L', 4: 'L', 5: 'E', 15: "E", 19: "Q", 25: "O" }
        },
        // 7 - DIO (orizzontale)
        { 
          id: 7, 
          direction: 'across', 
          clue: "Il Cantico è una lode che viene rivolta verso ... e alle sue creature", 
          answer: "DIO",
          row: 4, 
          col: 14, 
          number: 7,
          hints: { 1: 'D'}
        },
        // 8 - PREGHIERA (orizzontale)
        { 
          id: 8, 
          direction: 'across', 
          clue: "Questo testo è una ... che fa riferimento ad una visione positiva", 
          answer: "PREGHIERA",
          row: 9, 
          col: 8, 
          number: 8,
          hints: { 1: 'P', 3: 'E', 9: 'A' }
        },
        // 9 - Letteratura (verticale)
        { 
          id: 9, 
          direction: 'down', 
          clue: "È il testo poetico più antico della ... italiana", 
          answer: "LETTERATURA",
          row: 2, 
          col: 24, 
          number: 9, 
          hints: { 3: 'T', 4: 'T', 11: 'A' }
        },
        // 10 - UMBRO (verticale)
        { 
          id: 10, 
          direction: 'down', 
          clue: "Il Cantico venne scritto in volgare ... del XIII secolo", 
          answer: "UMBRO",
          row: 11, 
          col: 20, 
          number: 10 
        }
      ],
      
      currentCell: null,
      currentDirection: 'across'
    }
  },
  
  mounted() {
    this.initializeGrid();
    document.addEventListener('keydown', this.handleKeyPress);
  },
  
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress);
  },
  
  computed: {
    grid() {
      const grid = Array(this.gridSize.rows).fill(null).map(() => 
        Array(this.gridSize.cols).fill(null).map(() => ({ 
          letter: null, 
          isActive: false, 
          number: null,
          userLetter: '',
          isHint: false
        }))
      );
      
      // Popola la griglia con le parole
      this.words.forEach(word => {
        for (let i = 0; i < word.answer.length; i++) {
          const row = word.direction === 'across' ? word.row : word.row + i;
          const col = word.direction === 'across' ? word.col + i : word.col;
          
          if (row < this.gridSize.rows && col < this.gridSize.cols) {
            grid[row][col].letter = word.answer[i];
            grid[row][col].isActive = true;
            
            // Aggiungi numero solo alla prima cella
            if (i === 0) {
              grid[row][col].number = word.number;
            }
            
            // Проверяем, есть ли подсказка для этой позиции (i+1 потому что нумерация с 1)
            if (word.hints && word.hints[i + 1]) {
              grid[row][col].userLetter = word.hints[i + 1];
              grid[row][col].isHint = true;
            } else {
              // Mantieni la risposta dell'utente se esiste
              const cellKey = `${row}-${col}`;
              if (this.userAnswers[cellKey]) {
                grid[row][col].userLetter = this.userAnswers[cellKey];
              }
            }
          }
        }
      });
      
      return grid;
    },
    
    correctAnswers() {
      let correct = 0;
      let total = 0;
      
      this.grid.forEach((row) => {
        row.forEach((cell) => {
          if (cell.isActive) {
            total++;
            if (cell.userLetter.toUpperCase() === cell.letter) {
              correct++;
            }
          }
        });
      });
      
      return { correct, total };
    },
    
    percentage() {
      if (this.correctAnswers.total === 0) return 0;
      return Math.round((this.correctAnswers.correct / this.correctAnswers.total) * 100);
    }
  },
  
  methods: {
    initializeGrid() {
      // Inizializza le risposte utente vuote и добавляет подсказки
      this.grid.forEach((row, rowIndex) => {
        row.forEach((cell, colIndex) => {
          if (cell.isActive) {
            const key = `${rowIndex}-${colIndex}`;
            if (!this.userAnswers[key]) {
              // Если это подсказка, заполняем её, иначе пусто
              if (cell.isHint) {
                this.userAnswers[key] = cell.userLetter;
              } else {
                this.userAnswers[key] = '';
              }
            }
          }
        });
      });
    },
    
    selectCell(rowIndex, colIndex, cell) {
      if (!cell.isActive) return;
      
      let word = this.getWordAtCell(rowIndex, colIndex);
      this.currentCell = { row: rowIndex, col: colIndex };
      this.lastEntered = { row: rowIndex, col: colIndex };
      this.eraseDir = word.direction == "across" ? 
      (colIndex != word.col ? "across" : "down") : (rowIndex != word.row ? "down" : "across");

      if (word) {
        this.currentDirection = word.direction;
      }
    },
    
    handleKeyPress(e) {
      if (!this.currentCell) return;
      
      const key = e.key.toUpperCase();
      const cellKey = `${this.currentCell.row}-${this.currentCell.col}`;
      const cell = this.grid[this.currentCell.row][this.currentCell.col];
      
      if (/^[A-Z]$/.test(key)) {
        // Не позволяем менять подсказки
        if (!cell.isHint) {
          this.userAnswers[cellKey] = key;
          this.currentAns = this.getWordAtCell(this.currentCell.row, this.currentCell.col);
          this.moveToNextCell();
          this.lastEntered = { row: this.currentCell.row, col: this.currentCell.col };
          this.eraseDir = this.currentDirection;
        }
      } else if (e.key === 'Backspace') {
        // Не позволяем удалять подсказки
        if (!cell.isHint) {
          this.userAnswers[cellKey] = '';
        }else{ this.moveToPreviousCell();}
        this.moveToPreviousCell();
      } else if (e.key === 'ArrowRight') {
        this.moveRight();
      } else if (e.key === 'ArrowLeft') {
        this.moveLeft();
      } else if (e.key === 'ArrowDown') {
        this.moveDown();
      } else if (e.key === 'ArrowUp') {
        this.moveUp();
      }
    },
    
    moveToNextCell() {
      const { row, col } = this.currentCell;
      const currentWord = this.getWordAtCell(row, col);
      
      if (!currentWord) return;
      
      if (this.currentDirection === 'down') {
        // Для вертикальных слов: проверяем, есть ли еще строки в этом слове
        const wordEndRow = currentWord.row + currentWord.answer.length - 1;
        if (this.currentAns.direction === 'across') {
          return;
        }

        this.lastDirection = 'down';
        
        if (row < wordEndRow) {
          // Есть еще строки в этом слове, переходим на следующую
          let nextRow = row + 1;
          while (nextRow <= wordEndRow) {
            if (this.grid[nextRow][col].isActive) {
              // Если это подсказка, пропускаем и продолжаем
              if (this.grid[nextRow][col].isHint) {
                nextRow++;
                continue;
              }
              this.currentCell = { row: nextRow, col };
              return;
            }
            nextRow++;
          }
        }
      } else {
        // Для горизонтальных слов: проверяем, есть ли еще столбцы в этом слове
        const wordEndCol = currentWord.col + this.currentAns.answer.length - 1;

        if (this.currentAns.direction === 'down') {
          return;
        }

        this.lastDirection = 'across';
        
        if (col < wordEndCol) {
          console.log(col, wordEndCol)
          // Есть еще столбцы в этом слове, переходим на следующий
          let nextCol = col + 1;
          while (nextCol <= wordEndCol) {
            if (this.grid[row][nextCol].isActive) {
              // Если это подсказка, пропускаем и продолжаем
              if (this.grid[row][nextCol].isHint) {
                nextCol++;
                continue;
              }
              this.currentCell = { row, col: nextCol };
              return;
            }
            nextCol++;
          }
        }
      }
    },
    
    moveToPreviousCell() {
      const { row, col } = this.currentCell;
      const currentWord = this.getWordAtCell(row, col);
      
      if (!currentWord) return;

      let dir = this.eraseDir || this.currentDirection;
      
      if (dir === 'down') {
        // Для вертикальных слов: проверяем, есть ли еще строки в этом слове
        if (row > currentWord.row) {
          // Есть еще строки до текущей, переходим на предыдущую
          let prevRow = row - 1;
          while (prevRow >= currentWord.row) {
            if (this.grid[prevRow][col].isActive) {
              this.currentCell = { row: prevRow, col };
              this.selectCell(prevRow, col, this.grid[prevRow][col]);
              return;
            }
            prevRow--;
          }
        }
      } else {
        // Для горизонтальных слов: проверяем, есть ли еще столбцы в этом слове
        if (col > currentWord.col) {
          // Есть еще столбцы до текущего, переходим на предыдущий
          let prevCol = col - 1;
          console.log(prevCol)
          while (prevCol >= currentWord.col) {
            if (this.grid[row][prevCol].isActive) {
              // Если это подсказка, пропускаем и продолжаем
              this.currentCell = { row, col: prevCol };
              this.selectCell(row, prevCol, this.grid[row][prevCol]);
              return;
            }
            prevCol--;
          }
        }
      }
    },
    
    moveRight() {
      const { row, col } = this.currentCell;
      console.log("pre", row, col)
      for (let c = col + 1; c < this.gridSize.cols; c++) {
        if (this.grid[row][c].isActive) {
          this.currentCell = { row, col: c };
          break;
        }
      }
    },
    
    moveLeft() {
      const { row, col } = this.currentCell;
      for (let c = col - 1; c >= 0; c--) {
        if (this.grid[row][c].isActive) {
          this.currentCell = { row, col: c };
          break;
        }
      }
    },
    
    moveDown() {
      const { row, col } = this.currentCell;
      for (let r = row + 1; r < this.gridSize.rows; r++) {
        if (this.grid[r][col].isActive) {
          this.currentCell = { row: r, col };
          break;
        }
      }
    },
    
    moveUp() {
      const { row, col } = this.currentCell;
      for (let r = row - 1; r >= 0; r--) {
        if (this.grid[r][col].isActive) {
          this.currentCell = { row: r, col };
          break;
        }
      }
    },
    
    checkAnswers() {
      this.showResults = true;
    },
    
    reset() {
      this.userAnswers = {};
      this.showResults = false;
      this.currentCell = null;
      this.initializeGrid();
    },
    
    isCellSelected(rowIndex, colIndex) {
      return this.currentCell && 
             this.currentCell.row === rowIndex && 
             this.currentCell.col === colIndex;
    },
    
    getCellClass(cell, rowIndex, colIndex) {
      const classes = ['crossword-cell'];
      
      if (!cell.isActive) {
        classes.push('inactive');
        return classes.join(' ');
      }
      
      classes.push('active');
      
      if (cell.isHint) {
        classes.push('hint');
      }
      
      if (this.isCellSelected(rowIndex, colIndex)) {
        classes.push('selected');
      }
      
      if (this.showResults) {
        const cellKey = `${rowIndex}-${colIndex}`;
        if (this.userAnswers[cellKey]?.toUpperCase() === cell.letter) {
          classes.push('correct');
        } else if (this.userAnswers[cellKey]) {
          classes.push('incorrect');
        }
      }
      
      return classes.join(' ');
    },
    
    getWordAtCell(row, col) {
      return this.words.find(word => {
        if (word.direction === 'across') {
          return word.row === row && col >= word.col && col < word.col + word.answer.length;
        } else {
          return word.col === col && row >= word.row && row < word.row + word.answer.length;
        }
      });
    },
    
    isCellInWord(row, col, word) {
      if (!word) return false;
      
      if (word.direction === 'across') {
        // Для горизонтального слова: проверяем строку и диапазон столбцов
        return word.row === row && col >= word.col && col < word.col + word.answer.length;
      } else {
        // Для вертикального слова: проверяем столбец и диапазон строк
        return word.col === col && row >= word.row && row < word.row + word.answer.length;
      }
    }
  }
}
</script>

<template>
  <div class="crossword-container">
    <h1 style="color: #fb4242">🧩 Cruciverba su San Francesco</h1>
    <p style="color: #dcdbdb; margin-bottom: 30px;">
      Completa il cruciverba sulla vita di San Francesco d'Assisi
    </p>
    
    <div class="crossword-main">
      <!-- Griglia del cruciverba -->
      <div class="crossword-grid-wrapper">
        <div class="crossword-grid">
          <div 
            v-for="(row, rowIndex) in grid" 
            :key="rowIndex" 
            class="crossword-row"
          >
            <div
              v-for="(cell, colIndex) in row"
              :key="colIndex"
              :class="getCellClass(cell, rowIndex, colIndex)"
              @click="selectCell(rowIndex, colIndex, cell)"
            >
              <span v-if="cell.number" class="cell-number">{{ cell.number }}</span>
              <input
                v-if="cell.isActive"
                v-model="userAnswers[`${rowIndex}-${colIndex}`]"
                maxlength="1"
                class="cell-input"
                :readonly="showResults || cell.isHint"
                @focus="selectCell(rowIndex, colIndex, cell)"
              />
            </div>
          </div>
        </div>
        
        <div class="crossword-controls">
          <button @click="checkAnswers" class="check-button" v-if="!showResults">
            <i class="fa fa-check"></i> Verifica Risposte
          </button>
          <button @click="reset" class="reset-button">
            <i class="fa fa-refresh"></i> Ricomincia
          </button>
        </div>
        
        <div v-if="showResults" class="results-panel">
          <div class="score-display">
            <div class="score-circle" :style="{ borderColor: percentage >= 70 ? '#4caf50' : '#ff9800' }">
              <div class="score-number" :style="{ color: percentage >= 70 ? '#4caf50' : '#ff9800' }">
                {{ percentage }}%
              </div>
            </div>
            <div class="score-text">
              <p><strong>{{ correctAnswers.correct }}</strong> su <strong>{{ correctAnswers.total }}</strong> lettere corrette</p>
              <p v-if="percentage === 100" style="color: #4caf50; font-size: 1.2em;">
                🎉 Perfetto! Hai completato il cruciverba!
              </p>
              <p v-else-if="percentage >= 70" style="color: #4caf50;">
                👏 Ottimo lavoro! Continua così!
              </p>
              <p v-else style="color: #ff9800;">
                💪 Buon tentativo! Riprova!
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Domande -->
      <div class="clues-panel">
        <h2>📝 Domande</h2>
        
        <div class="clues-section">
          <h3>Orizzontali</h3>
          <div class="clue-list">
            <div 
              v-for="word in words.filter(w => w.direction === 'across')" 
              :key="word.id"
              class="clue-item"
            >
              <span class="clue-number">{{ word.number }}.</span>
              <span class="clue-text">{{ word.clue }}</span>
            </div>
          </div>
        </div>
        
        <div class="clues-section">
          <h3>Verticali</h3>
          <div class="clue-list">
            <div 
              v-for="word in words.filter(w => w.direction === 'down')" 
              :key="word.id"
              class="clue-item"
            >
              <span class="clue-number">{{ word.number }}.</span>
              <span class="clue-text">{{ word.clue }}</span>
            </div>
          </div>
        </div>
        
        <div class="help-box">
          <i class="fa fa-lightbulb-o"></i>
          <p><strong>Suggerimento:</strong> Clicca su una cella e usa la tastiera per inserire le lettere. Usa le frecce per navigare.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.crossword-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
}

.crossword-main {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 40px;
  margin-top: 40px;
}

.crossword-grid-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.crossword-grid {
  background: #181a1c;
  padding: 20px;
  border-radius: 10px;
  display: inline-block;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

.crossword-row {
  display: flex;
}

.crossword-cell {
  width: 30px;
  height: 30px;
  border: 1px solid #3a3c3e;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.crossword-cell.inactive {
  background: #0d0e0f;
  border-color: #0d0e0f;
}

.crossword-cell.active {
  background: white;
  cursor: pointer;
  border-color: #666;
}

.crossword-cell.active:hover {
  background: #f0f0f0;
}

.crossword-cell.hint {
  background: #e8f5e9 !important;
}

.crossword-cell.hint.selected {
  background: #c8e6c9 !important;
}

.crossword-cell.selected {
  background: #fff9c4 !important;
  border: 1px solid #666 !important;
}

.crossword-cell.correct {
  background: #c8e6c9 !important;
}

.crossword-cell.incorrect {
  background: #ffcdd2 !important;
}

.cell-number {
  position: absolute;
  top: 1px;
  left: 2px;
  font-size: 9px;
  font-weight: bold;
  color: #fb4242;
  z-index: 1;
}

.cell-input {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  color: #000;
  outline: none;
  caret-color: #fb4242;
  padding: 0;
}

.cell-input:read-only {
  cursor: default;
}

.crossword-controls {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.check-button,
.reset-button {
  padding: 15px 30px;
  border: none;
  border-radius: 10px;
  font-size: 1.1em;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 10px;
}

.check-button {
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
}

.check-button:hover {
  background: linear-gradient(135deg, #66bb6a, #81c784);
  transform: translateY(-3px);
}

.reset-button {
  background: #fb4242;
  color: white;
}

.reset-button:hover {
  background: #ff5252;
  transform: translateY(-3px);
}

.results-panel {
  background: #181a1c;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
}

.score-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.score-circle {
  width: 120px;
  height: 120px;
  border: 6px solid;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
}

.score-number {
  font-size: 2.5em;
  font-weight: bold;
}

.score-text {
  color: #dcdbdb;
}

.score-text p {
  margin: 10px 0;
}

.clues-panel {
  background: #181a1c;
  padding: 30px;
  border-radius: 10px;
  max-height: 800px;
  overflow-y: auto;
}

.clues-panel h2 {
  color: #fb4242;
  margin-top: 0;
  margin-bottom: 20px;
}

.clues-section {
  margin-bottom: 30px;
}

.clues-section h3 {
  color: white;
  margin-bottom: 15px;
  border-bottom: 2px solid #fb4242;
  padding-bottom: 10px;
}

.clue-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.clue-item {
  display: flex;
  gap: 10px;
  color: #dcdbdb;
  line-height: 1.5;
}

.clue-number {
  color: #fb4242;
  font-weight: bold;
  min-width: 25px;
}

.clue-text {
  flex: 1;
}

.help-box {
  background: rgba(251, 66, 66, 0.1);
  border: 2px solid rgba(251, 66, 66, 0.3);
  border-radius: 10px;
  padding: 20px;
  margin-top: 30px;
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

.help-box i {
  color: #ffd93d;
  font-size: 1.5em;
  flex-shrink: 0;
}

.help-box p {
  color: #dcdbdb;
  margin: 0;
  line-height: 1.6;
}

@media (max-width: 1200px) {
  .crossword-main {
    grid-template-columns: 1fr;
  }
  
  .crossword-grid {
    overflow-x: auto;
  }
  
  .clues-panel {
    max-height: none;
  }
}

@media (max-width: 768px) {
  .crossword-cell {
    width: 28px;
    height: 28px;
  }
  
  .cell-input {
    font-size: 14px;
  }
  
  .cell-number {
    font-size: 8px;
  }
  
  .crossword-controls {
    flex-direction: column;
  }
  
  .check-button,
  .reset-button {
    width: 100%;
    justify-content: center;
  }
}
</style>
